export default __webpack_public_path__ + "static/media/buyhistory.122f4fdb.svg";